var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11, 10) scale(0.65)",
    fill: "#033476"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.2,13.9h-3.2c-1.7,0-3,1.3-3,3v9.9c0,1.7,1.3,3,3,3h3.2c1.7,0,3-1.3,3-3v-9.9c0-1.7-1.3-3-3-3ZM9.2,26.8c0,.6-.4,1-1,1h-3.2c-.6,0-1-.4-1-1v-9.9c0-.6.4-1,1-1h3.2c.6,0,1,.4,1,1v9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,11.9h9.9c1.7,0,3-1.3,3-3v-3.9c0-1.7-1.3-3-3-3H5c-1.7,0-3,1.3-3,3v3.9c0,1.7,1.3,3,3,3ZM4,5c0-.6.4-1,1-1h9.9c.6,0,1,.4,1,1v3.9c0,.6-.4,1-1,1H5c-.6,0-1-.4-1-1v-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,2h-3.4c-1.7,0-3,1.3-3,3v3.9c0,1.7,1.3,3,3,3h3.4c1.7,0,3-1.3,3-3v-3.9c0-1.7-1.3-3-3-3ZM28,8.9c0,.6-.4,1-1,1h-3.4c-.6,0-1-.4-1-1v-3.9c0-.6.4-1,1-1h3.4c.6,0,1,.4,1,1v3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2,23.2h3.9c.7,0,1.3-.6,1.3-1.3,0-.7-.6-1.3-1.3-1.3h-3.9s0-3.9,0-3.9c0-.7-.6-1.3-1.3-1.3-.7,0-1.3.6-1.3,1.3v3.9s-3.9,0-3.9,0c-.7,0-1.3.6-1.3,1.3,0,.7.6,1.3,1.3,1.3,0,0,0,0,0,0h3.9s0,3.9,0,3.9c0,.7.6,1.3,1.3,1.3.7,0,1.3-.6,1.3-1.3v-3.9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app+.d3f895dccb67d843263a36ffdb1207a6.svg";
export { ForwardRef as ReactComponent };